import React from 'react'


function Projects() {
  return (
    <div className="mx-auto max-w-7xl">

        <section>
      <h1 className="text-4xl font-bold mt-5">Projects</h1>
      <div className="flex flex-col md:flex-row">
        <div className="md:w-10/12">
          <div className="mt-3">
            <div className="py-4">
              <div className="desc">
                <h4 className="font-bold bg-text">Workshop Management using Django</h4>
                <p className='py-3'>
                  <a target="_blank" rel="noopener noreferrer" className="inline-block px-4 py-2 bg-blue-500 text-white font-semibold rounded-lg" href="https://github.com/rahulktd/Workshop-management-">
                    Github Link
                  </a>
                </p>
              </div>
              <ul className="list-disc">
                <li>This project is a comprehensive workshop management system built using Django, a high-level Python web framework.</li>
                <li>It provides features to manage workshops, including participant registration, workshop scheduling, and resource allocation.</li>
                <li> With an intuitive user interface and robust functionality, this application simplifies the process of organizing and overseeing workshops effectively.</li>
              </ul>
            </div>

            <div className="py-4">
              <div className="desc">
                <h4 className="font-bold bg-text">Job Board</h4>
                <p className='py-3'>
                  <a target="_blank" className="inline-block px-4 py-2 bg-blue-500 text-white font-semibold rounded-lg" rel="noopener noreferrer" href="https://github.com/rahulktd/Job-Board">
                    Github Link
                  </a>
                </p>
              </div>
              <ul className="list-disc">
                <li>The Job Board project is a powerful Django-based web application designed to connect job seekers with employment opportunities. </li>
                <li> Employers can post job listings, while job seekers can search for relevant positions and submit their applications. </li>
                 <li> With advanced filtering options, seamless user experience, and secure authentication, this platform streamlines the job search process for both employers and job seekers.</li>                
              </ul>
            </div>

            <div className="py-4">
              <div className="desc">
                <h4 className="font-bold bg-text">Social Media using Django</h4>
                
                <p className='py-3'>
                  <a 
                  className="inline-block px-4 py-2 bg-blue-500 text-white font-semibold rounded-lg"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://github.com/rahulktd/social_media_django_project"
                  >
                    Github Link
                  </a>
                </p>
              </div>
              <ul className="list-disc">
              <li>Social Media is a dynamic Django project that enables users to connect and engage in a social networking environment.</li>
              <li>This application offers features such as user profiles, friend connections, post sharing, and real-time notifications.</li>
              <li> By leveraging Django's capabilities, this project provides a scalable and interactive social media experience.</li>
              </ul>
            </div>

            <div className="py-4">
              <div>
                <h4 className="font-bold bg-text" >E-Commerce App using Django</h4>
                
                <p className='py-3'>
                  <a
                    target="_blank"
                    className="inline-block px-4 py-2 bg-blue-500 text-white font-semibold rounded-lg"
                    rel="noopener noreferrer"
                    href="https://github.com/rahulktd/E-commerce-website-django"
                  >
                    Github Link
                  </a>
                </p>
              </div>
              <ul className="list-disc">
              <li>The E-Commerce App project is a feature-rich online shopping platform built with Django.</li>
              <li>It includes essential functionalities like product catalog management, shopping cart functionality, secure payment processing, and order tracking. </li>
              <li> With an intuitive interface and seamless integration, this application provides a delightful online shopping experience for customers and a robust backend for business owners.</li>
              </ul>
            </div>

            <div className="py-4">
              <div className="desc">
                <h4 className="font-bold bg-text">Real-time Chat App using Django</h4>
          
                <p className='py-3'>
                  <a
                    target="_blank"
                    className="inline-block px-4 py-2 bg-blue-500 text-white font-semibold rounded-lg"
                    rel="noopener noreferrer"
                    href="https://github.com/rahulktd/Real-time_Chat_App_django"
                  >
                    Github Link
                  </a>
                </p>
              </div>
              <ul className="list-disc">
              <li>Real-time Chat App using Django enables users to engage in instant messaging and group conversations.</li>
              <li>Leveraging Django Channels, it provides features like private messaging, online presence indicators, and message history. </li>
              <li>With its responsive design and real-time updates, this chat app fosters seamless communication among users.</li>
              </ul>
            </div>

            <div className="py-4">
              <div className="desc">
                <h4 className="font-bold bg-text">E-Commerce website using React</h4>
             
                <p className='py-3'>
                  <a
                    target="_blank"
                    className="inline-block px-4 py-2 bg-blue-500 text-white font-semibold rounded-lg"
                    rel="noopener noreferrer"
                    href="https://github.com/rahulktd/ecom-app-react"
                  >
                    Github Link
                  </a>
                </p>
              </div>
              <ul className='list-disc'>
                <li>E-Commerce website using React is a full-fledged online shopping platform developed with React.</li>
                <li>It offers a modern and intuitive user interface, along with features like product browsing, filtering, and secure checkout.</li>
                <li>With its responsive design and optimized performance, this website provides an engaging and efficient online shopping experience.</li>
              </ul>
            </div>

            <div className="py-4">
              <div className="desc">
                <h4 className="font-bold bg-text">Restaurant website using Material UI-React Project</h4>
             
                <p className='py-3'>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block px-4 py-2 bg-blue-500 text-white font-semibold rounded-lg"
                    href="https://github.com/rahulktd/restaurant-materialUI-react"
                  >
                    Github Link
                  </a>
                </p>
              </div>
              <ul className="list-disc">
                <li>The Restaurant website using Material UI-React Project showcases a visually appealing and user-friendly restaurant website.</li>
                <li>It offers a seamless browsing experience, including features like menu presentation, table reservations, and contact information.</li>
                <li>With its elegant design and responsive layout, this website enhances the online presence of a restaurant and attracts potential customers.</li>
              </ul>
            </div>

            <div className="py-4">
              <div className="desc">
                <h4 className="font-bold bg-text">Todo App using Django</h4>
           
                <p className='py-3'>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block px-4 py-2 bg-blue-500 text-white font-semibold rounded-lg"
                    href="https://github.com/rahulktd/ToDo-App"
                  >
                    Github Link
                  </a>
                </p>
              </div>
              <ul className="list-disc">
                <li>Todo App using Django is a simple yet powerful task management application.</li>
                <li>It allows users to create, organize, and track their to-do lists effectively.</li>
                <li>With features such as task prioritization, due date reminders, and user authentication, this app helps users stay organized and focused.</li>
              </ul>
            </div>

            <div className="py-4">
              <div className="desc">
                <h4 className="font-bold bg-text">Todo App using Flask</h4>
   
                <p className='py-3'>
                  <a
                    target="_blank"
                    className="inline-block px-4 py-2 bg-blue-500 text-white font-semibold rounded-lg"
                    rel="noopener noreferrer"
                    href="https://github.com/rahulktd/Todo-app-flask"
                  >
                    Github Link
                  </a>
                </p>
              </div>
              <ul className="list-disc">
                <li>Todo App using Flask is a lightweight task management application developed with Flask, a micro web framework in Python.</li>
                <li>It provides essential functionality like task creation, editing, and marking tasks as completed.</li>
                <li>With its minimalistic design and intuitive user interface, this app helps users manage their tasks efficiently.</li>
              </ul>
            </div>
            

          </div>
        </div>
      </div>
    </section>

    </div>
  )
}

export default Projects